import { render, staticRenderFns } from "./UiDatepicker.vue?vue&type=template&id=1d083fae"
import script from "./UiDatepicker.vue?vue&type=script&lang=js"
export * from "./UiDatepicker.vue?vue&type=script&lang=js"
import style0 from "./UiDatepicker.vue?vue&type=style&index=0&id=1d083fae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports